import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "react-cookies";
import ContentLoader from "react-content-loader";
import {
  apiUrl,
  uniqueID,
  placeholderImage, innerbanner
} from "../Settings/Config";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import noProduct from "../../common/images/no-product.png";
class Categories extends Component {
  constructor(props) {
    super(props);
    const seletedAvilablityId = cookie.load("availability") ?? "";
    const outletID = cookie.load("outletID") ?? "";
    this.state = {
      loading: true,
      loginPopup: false,
      menuNavication: [],
      seletedAvilablityId: seletedAvilablityId,
      outletID: outletID,
      trigerCart: false,
      openAvailPopup: false,
      showNoProduct: false,
    };
  }
  componentDidMount() {
    this.loadMenuNavication();
  }

  loadMenuNavication() {
    axios
      .get(
        `${apiUrl}products/categories?uniqueID=${uniqueID}&outletID=${this.state.outletID}&availabilityID=${this.state.seletedAvilablityId}`
      )
      .then((res) => {
        if (res.data.status === "ok") {
          const result = res.data.result;
          this.setState({
            menuNavication: result,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  updateStateValue = (field, value) => {
    this.setState({ [field]: value });
  };
  gotoCategory(link, e) {
    e.preventDefault();
    this.props.history.push(link);
  }

  render() {
    return (
      <div className="cover">
        <Header
          trigerCart={this.state.trigerCart}
          updateStateValue={this.updateStateValue.bind(this)}
          loginPopup={this.state.loginPopup}
          openAvailPopup={this.state.openAvailPopup}
        />

        <div className="inner-banner">
          <img src={innerbanner} alt="banner" />
          <div className="inner-caption">Categories</div>
        </div>
        <div className="innerpage">
          <div className="container">
            <div class="menu_list">
              {this.state.loading === true ? (
                [0, 1, 2, 3].map((item) => {
                  return (
                    <div key={item} class="product_sec green_back">
                      <ContentLoader
                        viewBox="0 0 290 280"
                        height={280}
                        width={290}
                      >
                        <rect
                          x="3"
                          y="3"
                          rx="10"
                          ry="10"
                          width="300"
                          height="180"
                        />
                        <rect
                          x="6"
                          y="190"
                          rx="0"
                          ry="0"
                          width="292"
                          height="20"
                        />
                        <rect
                          x="4"
                          y="215"
                          rx="0"
                          ry="0"
                          width="239"
                          height="20"
                        />
                        <rect
                          x="4"
                          y="242"
                          rx="0"
                          ry="0"
                          width="274"
                          height="20"
                        />
                      </ContentLoader>
                    </div>
                  );
                })
              ) : this.state.menuNavication.length > 0 ? (
                this.state.menuNavication.map((item, index) => {
                  return (
                    <div class="product_sec green_back" key={index}>
                      <Link
                        to={`/products/${item.categorySlug}`}
                        title="Main Menu"
                        class="categ category_actives"
                      >
                        <img
                          src={
                            item.categoryImage !== "" &&
                            item.categoryImage !== null
                              ? item.categoryImage
                              : placeholderImage
                          }
                          alt=""
                        />
                        <div class="product_container">
                          <div class="product_caption">
                            <h3>{item.categoryCustomTitle}</h3>
                          </div>
                        </div>
                      </Link>
                    </div>
                  );
                })
              ) : (
                <div className="no-products-container">
                  <img src={noProduct} alt="No Products" />
                  <h2>No Products Found</h2>
                  <p>
                    We couldn't find any matching products. Try changing your
                    filters or search keywords.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
        <Footer
          {...this.props}
          updateStateValue={this.updateStateValue.bind(this)}
        />
      </div>
    );
  }
}
export default Categories;
